import { useEffect, useState } from "react";
import Pagination from "./Pagination";
import {
  getProviderAvilableBalance,
} from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Spinner from "../../Spin/Spinner";

const ProviderWalletAvilableBalance = () => {
  const token = useSelector((store) => store.userReducer.token);

  const [loading, setLoading] = useState(false); 
  const [tableData, setTableData] = useState({ data: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getProviderWalletData = async () => {
    setLoading(true);
    try {
      const response = await getProviderAvilableBalance(token, currentPage);
      setTableData(response.data);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (token) getProviderWalletData();
  }, [currentPage, token]);


  return (
    <div className="settlement-report-container">
      <div className="settlement-report-excel">
        <div className="settlement-report-title">Provider Avilable Balance</div>
      </div>

      <div className="settlement-report-table-wrapper">
        <table className="settlement-report-table">
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>Org Name</th>
              <th>Avilable Balance</th>
              <th>Created At</th>
             <th>Updated At</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5">Loading...</td>
              </tr>
            ) : tableData.data?.length > 0 ? (
              tableData.data.map((row, i) => (
                <tr key={i}>
                  <td>{row.providerName}</td>
                  <td>{row.orgName}</td>
                  <td>{row.balance}</td>
                  <td>
                    {new Date(row.createdAt).toLocaleDateString("en-GB")}{" "}
                    {new Date(row.createdAt).toLocaleTimeString("en-GB", {
                      hour12: true,
                    })}
                  </td>
                    <td>
                    {new Date(row.updatedAt).toLocaleDateString("en-GB")}{" "}
                    {new Date(row.updatedAt).toLocaleTimeString("en-GB", {
                      hour12: true,
                    })}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />


      {(loading) && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default ProviderWalletAvilableBalance
